import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import FactoryIcon from "@mui/icons-material/Factory";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

export default function WarehouseTransferBillWarehouseView({
  selectedSource,
  selectedDestination,
}) {
  return (
    <Box
      sx={{
        width: "100%",
        padding: 1,
        borderRadius: 2,
      }}
    >
      <Stepper activeStep={2} alternativeLabel>
        <Step key={selectedSource?.warehouseName}>
          <StepLabel
            StepIconComponent={
              selectedSource
                ? selectedSource?.warehouseType === "Factory"
                  ? FactoryIcon
                  : LocalShippingIcon
                : FactoryIcon
            }
            style={{ color: "#EF5D8E" }}
          >
            {selectedSource?.warehouseName + " (Source)"}
          </StepLabel>
        </Step>
        <Step key={selectedDestination?.warehouseName}>
          <StepLabel
            StepIconComponent={
              selectedDestination
                ? selectedDestination?.warehouseType === "Factory"
                  ? FactoryIcon
                  : LocalShippingIcon
                : FactoryIcon
            }
            style={{ color: "#EF5D8E" }}
          >
            {selectedDestination?.warehouseName + " (Destination)"}
          </StepLabel>
        </Step>
      </Stepper>
    </Box>
  );
}
